<template>
  <div>
    <div class="card-footer text-center bg-transparent mb-3">
      <p class="mb-4">{{ $i18n.t('SignUpConfirmation.link_application') }}</p>
      <div class="img-bottom-wrapper">
        <a class="m-l-10 m-r-10 footer-link link-google-play"
           href="https://play.google.com/store/apps/details?id=com.hospimedia.switchapp" target="_blank">
          <img alt="logo-black" src="../assets/img/Google-Play.png">
        </a>
        <a class="m-l-10 m-r-10 footer-link link-app-store"
           href="https://apps.apple.com/fr/app/teamsquare-sant%C3%A9/id1380639450" target="_blank">
          <img alt="logo-black" src="../assets/img/Logo-App-Store.png">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "FooterConfirmationPage"
  }
</script>

<style scoped>
  .card-footer {
    border-top: none;
  }

  .card-footer img {
    width: 120px;
    height: 45px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterConfirmationPage.vue